import React, { useState, useEffect } from 'react'
import moment from 'moment-jalaali'
import {
  Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, makeStyles,
} from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'
// import Button from '@material-ui/core/Button'
import EditIcon from 'src/icons/EditIcon'
import MUIDataTable from 'mui-datatables'
import { useNavigate } from 'react-router-dom'
import { ThemeProvider } from '@material-ui/core/styles'
import { useDispatch, useSelector } from 'react-redux'
import { deleteEvent, getEvents, selectorAllEvents } from 'src/app/slices/eventSlice'
import DeleteIcon from 'src/icons/DeleteIcon'
import { getMuiTheme } from '../../utils/TableStyle'
import muiDefaultOptions from '../../constants/muiTableOptions'

const useStyle = makeStyles(() => ({
  root: {
    '&.MuiPaper-root': {
      // borderRadius: '100px',
    },
  },
  icons: {
    color: '#b2b6c0',
    transition: '0.2s',
    '&:hover': {
      color: '#f39994',
    },
  },
  deleteDialog: {
    '& .MuiDialog-paperWidthSm': {
      // width: '587px',
      width: '50%',
      height: '189px',
      borderRadius: '20px',
      padding: '0 0 11px',
      backgroundColor: '#fff',
      margin: '22px 94.6px 36px 110.5px',
    },
    '& .MuiBackdrop-root': {
      opacity: '0.6 !important',
      backgroundColor: '#363853',
    },
  },
  dialogHeader: {
    width: '100%',
    height: '53px',
    backgroundImage: 'linear-gradient(#f5aca8, #eb5c55)',
    color: '#ffffff',
    '& .MuiTypography-h6': {
      fontWeight: '600',
      fontSize: '17px',
      '@media (max-width: 960px)': {
        fontSize: '15px',
      },
    },
  },
  dialogDesc: {
    fontWeight: '600',
    fontSize: '17px',
    marginTop: '10px',
    color: '#363853',
    '@media (max-width: 960px)': {
      fontSize: '14px',
    },
  },
  dialogButtons: {
    marginRight: '20px',
  },
  deleteModalBtn: {
    backgroundColor: '#ffffff',
    width: '25%',
    height: '37px',
    borderRadius: '20px',
    color: '#e6332a',
    textAlign: 'center',
    border: '2px solid #e6332a',
    boxShadow: '0 2px 6px 0 rgba(197, 0, 0, 0.36)',
    fontWeight: '600',
    '&:hover': {
      backgroundColor: '#e6332a',
      color: '#ffffff',
    },
  },
  cancelModalBtn: {
    backgroundColor: '#ffffff',
    width: '25%',
    height: '37px',
    borderRadius: '20px',
    color: '#e6332a',
    textAlign: 'center',
    border: '2px solid #e6332a',
    boxShadow: '0 2px 6px 0 rgba(197, 0, 0, 0.36)',
    fontWeight: '600',
    '&:hover': {
      backgroundColor: '#e6332a',
      color: '#ffffff',
    },
  },
}))

const AdminList = () => {
  const classes = useStyle()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const events = useSelector(selectorAllEvents)
  const count = useSelector((state) => state.discounts.totalHits)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(muiDefaultOptions.rowsPerPage)
  const [eventToDelete, setEventToDelete] = useState(null)
  const [refresh, setRefresh] = useState(false)
  const loggedInUser = useSelector((state) => state.user.role.roleId)

  useEffect(() => {
    dispatch(getEvents())
  }, [rowsPerPage, page, refresh])

  const handleEdit = (state) => navigate(`edit-event/${state.id}`, { state })
  const handleUsers = (state) => navigate('event-users', { state })

  const handleClose = (shouldDelete) => {
    if (shouldDelete) {
      setRefresh(!refresh)
      dispatch(deleteEvent(
        eventToDelete, () => setRefresh(!refresh),
      ))
      setEventToDelete(null)
    }
    // setGroupToDelete(null)
  }

  const COLUMNS = [
    {
      name: 'row',
      label: 'ردیف',
      options: {
        sort: false,
        filter: false,
        customBodyRender: (value, { rowIndex }) => {
          return (
            <p style={{
              color: '#000',
              whiteSpace: 'nowrap',
              float: window.outerWidth < 960 ? 'left' : '',
            }}
            >
              {rowIndex + 1}
            </p>
          )
        },
      },
    },
    {
      name: 'title',
      label: 'عنوان رویداد',
    },
    {
      name: 'subject',
      label: 'موضوع رویداد',
    },
    {
      name: 'category',
      label: 'رده سنی',
      options: {
        customBodyRender: (value) => value?.name,
      },
    },
    {
      name: 'closingDate',
      label: 'تاریخ بستن',
      options: {
        customBodyRender: (value) => (value ? moment(value)?.format('jYYYY/jMM/jDD') : '--'),
      },
    },
    {
      name: 'expierDate',
      label: 'تاریخ انقضا',
      options: {
        customBodyRender: (value) => (value ? moment(value)?.format('jYYYY/jMM/jDD') : '--'),
      },
    },
    {
      name: 'مدیریت',
      label: '',
      options: {
        customBodyRenderLite: (index) => {
          const data = events[index]

          return (
            <>
              {loggedInUser === 2 ? (
                <>
                  <IconButton
                    onClick={() => handleEdit(data)}
                  >
                    <EditIcon className={classes.icons} />
                  </IconButton>
                  <IconButton onClick={() => {
                    setEventToDelete(data?.id)
                  }}
                  >

                    <DeleteIcon
                      className={classes.icons}
                    />
                  </IconButton>
                </>
              ) : (
                <Button
                  variant="contained"
                  color="primary"
                  style={{ margin: '8px 0' }}
                  onClick={() => handleUsers(data)}
                >
                  مشاهده نتایج
                </Button>
              )}
            </>

          )
        },
      },
    },
  ]

  return (
    <>

      <ThemeProvider theme={getMuiTheme}>
        <MUIDataTable
          data={events}
          columns={COLUMNS}
          options={{
            ...muiDefaultOptions,

            rowsPerPage,
            page,
            count,

            serverSide: true,
            filter: false,
            print: false,
            download: false,
            search: false,

            rowHover: true,
            selectableRows: 'none',
            // onRowsDelete: (selectedRows) => handleDelete(selectedRows),
            searchable: false,
            onTableChange: (action, state) => {
              switch (action) {
                case 'changePage': {
                  setPage(state.page)
                  break
                }
                case 'changeRowsPerPage': {
                  setRowsPerPage(state.rowsPerPage)
                  break
                }
                default: {
                  return null
                }
              }
              return null
            },
          }}
        />
      </ThemeProvider>
      <Dialog
        className={classes.deleteDialog}
        open={eventToDelete}
        // onClose={() => handleClose(false)}
        onClose={() => setEventToDelete(null)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className={classes.dialogHeader} id="alert-dialog-title">حذف رویداد</DialogTitle>
        <DialogContent>
          <DialogContentText className={classes.dialogDesc} id="alert-dialog-description">
            آیا از حذف این رویداد اطمینان دارید؟
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.dialogButtons}>
          <Button onClick={() => setEventToDelete(null)} className={classes.cancelModalBtn}>
            لغو
          </Button>
          <Button onClick={() => handleClose(true)} className={classes.deleteModalBtn} autoFocus>
            بلی
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default AdminList
